/**
 * DoorSensor Template Components
 * 
 * 門感應器顯示 Modal Templates (只讀，無控制)
 */

import { Template01_Status } from './Template01_Status';

// Named exports
export { Template01_Status } from './Template01_Status';

// Template registry for dynamic loading
export const DoorSensorTemplates = {
  Template01: () => import('./Template01_Status').then(m => m.Template01_Status),
} as const;

// Default export
export default Template01_Status;
